import React from "react"
import Select from 'react-select';

function ApplyFields({ applyCheckboxRule, applyDataProtection, applyIntro, applyParagraphTitle,formHtml,fieldGroupName,formOnlineLocation,formPostLocation,applyContent }){

const hearValues = [{value: "Please Select",label: "Please Select"},{value: "Social Media",label: "Social Media"},{value: "Newpaper",label: "Newpaper"},{value: "Word of Mouth",label: "Word of Mouth"},{value: "Website",label: "Website"}]

  const customStyles = {
    option: (provided,selectedOption) => ({
      ...provided,
      color: selectedOption ? "white" : "white",
      color: selectedOption.isFocused ? 'black' : '#041e41',
      backgroundColor: selectedOption.isFocused ? 'rgba(4,30,65,.1)' : 'white',
      fontSize: '22px',
      fontWeight: '200',
    }),
    control: (provided,selectedOption) => ({
      ...provided,
      backgroundColor: 'white',
      border: '0px',
      borderRadius: '30px',
    }),
    singleValue: (provided,selectedOption) => ({
      ...provided,
      color: '#666',

      backgroundColor: 'white',
      fontSize: '22px',
      fontWeight: '200',
      padding: '20px',
      transition: 'opacity 300ms',
    }),
  }

return (
  <section className="content very-light-blue-background">
   <div className="one-hundred-spacer"></div>
   <div className="content-block">
      <div className="two-thirds-block">
         <div dangerouslySetInnerHTML={{ __html: applyContent }}/>

         <div className="data-title">Data Protection:</div>
            <div className="data-para" dangerouslySetInnerHTML={{ __html: applyDataProtection }}/>

            <div className="data-para_block" dangerouslySetInnerHTML={{ __html: applyCheckboxRule }}/>

         <form action="https://secure.htb.co.uk/savings/openAccount?" method="get" target="_blank" className="form-apply" noValidate="novalidate">
         <div dangerouslySetInnerHTML={{ __html: formHtml }}/>


         <div className="cta-help-field-holder">
            <h4>How did you hear about us?</h4>

            <div className="im-select-dropdown-holder" data-children-count="1">
            <div className="navy-down-icon"></div>


             <Select name="hear" styles = { customStyles } options={hearValues} defaultValue={hearValues[0]} />
            </div>
         </div>

         <div className="apply-btns">
               <button type="submit" className="apply-btn" formAction="https://secure.htb.co.uk/savings/openAccount?">Apply Online</button>
         </div>

         <div className="one-hundred-spacer"></div>
         <div className="eighty-spacer hide-on-responsive"></div>
         </form>
      </div>
   </div>
</section>
 )
  }


export default ApplyFields
